import React from "react";
import {
  Button,
  IconButton,
  Table,
  TableContainer,
  TableRow,
  TableHead,
  TableBody,
  TableCell
} from "@material-ui/core";
import StarBorderRoundedIcon from '@material-ui/icons/StarBorderRounded';
import StarRateRoundedIcon from '@material-ui/icons/StarRateRounded';

const KEY_ARRAY= ['DownloadURL', 'Source Language', 'Target Language', 'Star', 'CreatedAt'];

export default function TableComponent({ onStarClick, data }) {
  if(!Array.isArray(data) || !data.length || !data[0]) {
    return (null);
  }

  return (
    <TableContainer>
      <Table className="mb-0">
      <TableHead>
        <TableRow>
          {KEY_ARRAY.map(key => (
            <TableCell style={{
            }} key={key}>{key}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((element) => {
          let { id, s3DownloadAddress, sourceLanguage, targetLanguage, isStarred, createdAt} = element;
          return (
          <TableRow key={id}>
            <TableCell>
              {
                s3DownloadAddress ?
                <Button
                  target="_blank"
                  href={s3DownloadAddress}
                  color="primary"
                  variant="contained"
                >
                  Download
                </Button> :
                <Button
                  disabled
                  variant="contained"
                >
                  Not Available
                </Button>
              }
            </TableCell>
            <TableCell>{sourceLanguage}</TableCell>
            <TableCell>{targetLanguage}</TableCell>
            <TableCell>{
              isStarred ?
                <IconButton color="primary" aria-label="starred" onClick={() =>onStarClick(id, !isStarred)}>
                  <StarRateRoundedIcon />
                </IconButton>
               :
               <IconButton color="primary" aria-label="notstarred" onClick={() =>onStarClick(id, !isStarred)}>
                <StarBorderRoundedIcon />
              </IconButton>
              }
            </TableCell>
            <TableCell>{createdAt}</TableCell>
          </TableRow>
          )
        })}
      </TableBody>
    </Table>
    </TableContainer>

  );
}
